import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { BorrowerSegment } from 'ng2-app/models/borrower/BorrowerSegment.struct';
import { BulkSubmissionBorrower } from 'ng2-app/models/borrower/BulkSubmissionBorrower.struct';
import { LoanProduct } from 'ng2-app/models/dto/loan-product.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BulkSubmissionService {
  constructor(
    private http: ApiHttpClient,
  ) {}

  getBorrowers(): Observable<BulkSubmissionBorrower[]> {
    return this.http.get<BulkSubmissionBorrower[]>(`${environment.API_URL}/bulk-submission-borrowers`);
  }

  submitBorrowers(borrowerIds: number[], loanProductIds: number[]): Observable<any> {
    return this.http.post<any>(`${environment.API_URL}/bulk-submit-borrowers`, {
      borrowerIds,
      loanProductIds,
    });
  }

  getSubmittableLoanProducts(): Observable<LoanProduct[]> {
    return this.http.get<LoanProduct[]>(`${environment.API_URL}/bulk-submittable-loan-products`);
  }

  getBorrowerSegments(): Observable<BorrowerSegment[]> {
    return this.http.get<BorrowerSegment[]>(`${environment.API_URL}/borrower-segments`);
  }

}
